<div class="h-screen w-screen flex py-8 md:p-0 md:items-center justify-center">
  <div
    class="bg-offwhite-100 rounded-xl center w-11/12 h-[95%] md:w-3/4 login-container-height shadow-[0_8px_30px_rgb(0,0,0,0.12)]">
    <div class="flex flex-col h-full  ">
      <div class="flex flex-row h-full">
        <div class="flex flex-col h-full  w-full p-2 md:p-6 pr-2 flex-grow  overflow-y-auto">
          <div class="flex md:items-end items-center px-4 py-6"
            [ngClass]="{'justify-between':displayAudit || displayAuditStart,'justify-stretch':!displayAudit && !displayAuditStart}">
            @if (!isBluebird) {
              <div class=" w-1/6">
                <img src="/assets/logo.png" class="object-scale-down"
                  [ngClass]="{'max-h-12':displayAudit,'max-h-24':!displayAudit}" />
                </div>
              }
              @if (isBluebird) {
                <div class=" w-1/6">
                  <img src="/assets/bluebirdlogo.png" class="object-scale-down"
                    [ngClass]="{'max-h-12':displayAudit,'max-h-24':!displayAudit}" />
                  </div>
                }

                @if (displayAuditStart) {
                  <h1 class="text-2xl md:text-6xl self-baseline">Welcome</h1>
                }
                @if (displayAudit && auditResult.Audit.Questions.length>1 && auditResult.Audit.Questions.length<16) {
                  <div
                    class="md:flex w-3/5 self-end hidden">
                    @for (q of auditResult.Audit.Questions; track q) {
                      <div class=" p-1"
                        [ngStyle]="{ 'flex': '1 1 ' + (100 / auditResult.Audit.Questions.length) + '%' }">
                        <div class=" min-h-5 w-full  rounded-md border-2"
                          [ngClass]="{'bg-green-400':q.IsAnswered,'bg-grey-500':!q.IsAnswered&&q.HasViewed ,'border-green-400':q.QuestionID==currentQuestion.QuestionID,'border-grey-500':q.QuestionID!=currentQuestion.QuestionID}">
                        </div>
                      </div>
                    }
                  </div>
                }
                @if (displayAudit && auditResult.Audit.Questions.length>=16) {
                  <div
                    class="md:flex w-3/5 self-end hidden">
                    @for (q of auditResult.Audit.Questions; track q; let first = $first; let last = $last) {
                      <div class=" "
                        [ngStyle]="{ 'flex': '1 1 ' + (100 / auditResult.Audit.Questions.length) + '%' }">
                        <div class=" min-h-5 w-full border-y-2 border-grey-500"
                          [ngClass]="{'bg-green-400':q.IsAnswered,'rounded-l-full border-l-2':first,'rounded-r-full border-r-2':last,'bg-green-50':!q.IsAnswered&&q.HasViewed}">
                        </div>
                      </div>
                    }
                  </div>
                }
                @if (displayAudit) {
                  <div class=" md:self-end">
                    <p class="text-grey-900 md:text-2xl">{{currentPageCount}} / {{pageCount}}</p>
                  </div>
                }
                @if (displayAuditStart) {
                  <div class="w-1/6">
                  </div>
                }
              </div>

              @if (!isLoading) {
                <div class="border-t-2 my-2 border-t-grey-500">
                </div>
              }
              @if (displayAuditStart) {
                <div
                  class="flex-col h-full justify-between flex flex-grow items-center md:p-8">
                  <div class="flex flex-col items-center justify-between px-2">
                    <h2 class="mt-6 text-center text-sm md:text-base">You have been invited to complete </h2>
                    <h1 class="text-green-400 text-center md:mt-4 mt-2 text-3xl md:text-5xl">
                      {{auditResult.Audit.AuditName}}
                    </h1>
                    <h2 class="md:mt-4 mt-5  text-sm md:text-base">
                      by the team at
                    </h2>
                    <h1 class="text-green-400 text-xl md:text-3xl md:mt-3 mt-1">
                      {{auditResult.Audit.CustomerName}}
                    </h1>
                  </div>
                  <div class="flex justify-center mb-6 mt-12">
                    <button class="btn-primary md:text-3xl text-lg font-bold rounded-lg md:py-4"
                    (click)="startAudit()">Click to Begin</button>
                  </div>
                </div>
              }
              @if (isLoading) {
                <div class="flex-col flex flex-grow items-center md:p-8">
                  <h1 class="text-6xl text-center">Loading...</h1>
                </div>
              }
              @if (invalidAudit) {
                <div class="flex-col flex flex-grow items-center md:p-8 mt-2">
                  <h1 class="text-2xl md:text-4xl text-center">No Further Responses</h1>
                  <h2 class="md:text-lg text-base font-normal md:font-bold md:mt-8 text-center">The link provided
                    is no longer accepting further responses, please
                    contact the provider of
                  the link if this is not expected</h2>
                </div>
              }
              @if (auditCompleted) {
                <div class="flex-col flex flex-grow items-center md:p-8 mt-6">
                  <h1 class="md:text-6xl text-2xl text-center">Thank You</h1>
                  <h2 class="md:mt-8 mt-2 text-lg text-center">This response can only be submitted once.</h2>
                </div>
              }
              @if (somethingWrong) {
                <div class="flex-col flex flex-grow items-center md:p-8">
                  <h1 class="md:text-6xl text-2xl  text-center">Something Went Wrong...</h1>
                  <p class="md:mt-8 mt-2 text-lg text-center md:text-2xl">Sorry we are not able to process your
                    request, please try
                  again later.</p>
                </div>
              }
              @if (displayAudit) {
                <div class="p-2 flex flex-col flex-grow justify-between ">
                  <app-public-audit-question [(auditQuestion)]="currentQuestion"
                  class="w-auto"></app-public-audit-question>
                  <div class="flex flex-col-reverse md:flex-row px-5 mt-4 justify-between items-end">
                    <button class="btn-primary rounded-lg w-full md:w-auto"
                      [disabled]="currentQuestion.IsRequired && !currentQuestion.IsAnswered"
                      (click)="nextQuestion()">@if (!lastQuestion) {
                      <span class="">Next Question</span>
                      }@if (lastQuestion) {
                      <span
                      class="">Finish</span>
                    }</button>
                    @if (currentQuestion.IsRequired && !currentQuestion.IsAnswered) {
                      <p class="text-danger-base">
                      Please complete the question to continue.</p>
                    }
                  </div>
                </div>
              }
              @if (displaySubmitting) {
                <div
                  class="flex flex-col flex-grow justify-center py-10 items-center px-3">
                  <h1 class="text-green-400 mt-4">Submitting...</h1>
                </div>
              }
              @if (displaySummary) {
                <div class="flex flex-col mt-4 justify-center py-10 items-center px-3">
                  <h2 class="text-center text-xl">Thank you for taking the time to complete</h2>
                  <h1 class="text-center text-3xl text-green-400 mt-2">{{auditResult.Audit.AuditName}}</h1>
                  <h2 class="text-center text-xl mt-2">You can now safely close this window</h2>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
